<!--待审核 查看详情跳转的页面-->
<template>
    <div>
        <div class="button-area">

            <Button @click="back()" class="button-right">返回</Button>
        </div>
        <div class="form-area">
            <Form style="width: 900px;margin-bottom:20px;" :model="model" :label-width="110" label-position="left" inline>
                <div style="text-align:center;line-height:4;font-weight:600;font-size:15px;">企业基础信息</div>
                <FormItem :class="{'model-hidden': true}" label="文本框">
                    <Input readonly v-model="model.id" type="text"></Input>
                </FormItem>
                <FormItem label="企业名称">
                    <Input readonly v-model="model.companyName" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="统一信用代码">
                    <Input readonly v-model="model.unifiedSocialCreditCode" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="法人姓名">
                    <Input readonly v-model="model.legalman" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="手机号">
                    <Input readonly v-model="model.contactMobile" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="公司成立日期">
                    <Input readonly v-model="model.formatBuildTime" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="企业详细地址">
                    <Input readonly v-model="model.companyAddress" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="联系人">
                    <Input readonly v-model="model.concatName" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="联系人电话">
                    <Input readonly v-model="model.mobilePhone" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="经营范围">
                    <Input readonly v-model="model.businessRange" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="联系人固定电话">
                    <Input readonly v-model="model.concatPhone" style="width:320px" type="text"></Input>
                </FormItem>

                <FormItem label="所属地区名称">
                    <Input readonly :value="model.city+' / '+model.area+' / '+model.town" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="联系地址">
                    <Input readonly v-model="model.concatAddress" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="申请时间">
                    <Input readonly v-model="model.formatCreateTime" style="width:320px" type="text"></Input>

                </FormItem>
                <br>
                <FormItem label="营业执照照片">
                    <previewImg v-if="model.businessLicense && model.businessLicense.url" style="width:200px;height:200px;margin-right:20px;margin-bottom:20px;" :src="model.businessLicense.url" />
                    <img style="width: 200px;" v-else src="../../../../assets/noPic.jpg" alt="">
                </FormItem>
                <br>
                <FormItem label="企业实名认证表">
                    <previewImg v-if="model.certificationMaterials && model.certificationMaterials.url" style="width:200px;height:200px;margin-right:20px;margin-bottom:20px;" :src="model.certificationMaterials.url" />
                    <img style="width: 200px;" v-else src="../../../../assets/noPic.jpg" alt="">
                </FormItem>
                <div style="text-align:center;line-height:4;font-weight:600;font-size:15px;">知识产权</div>
                <FormItem label="商标" style="width:100%;margin-right:0;">
                   <div v-if="model.shangbiao&&model.shangbiao!=''" class="img-con">
                       <previewImg style="width:150px;height:150px;margin-right:20px;margin-bottom:20px;" v-for="item in model.shangbiao" :key="item.uri" :src="item.url" />
                   </div>
                   <img style="width: 200px;" v-else src="../../../../assets/noPic.jpg" alt="">
                </FormItem>
                <FormItem label="网站地址">
                    <Input readonly v-model="model.website" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="专利">
                    <Input readonly v-model="model.zhuanliCount" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="著作权">
                    <Input readonly v-model="model.zhuzuoquanCount" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="资质证书">
                    <Input readonly v-model="model.zizhizhengshuCount" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="授权委托书">
                    <previewImg v-if="model.creditReportAuth && model.creditReportAuth.url" style="width:200px;height:200px;margin-right:20px;margin-bottom:20px;" :src="model.creditReportAuth.url" />
                    <img style="width: 200px;" v-else src="../../../../assets/noPic.jpg" alt="">
                </FormItem>
                <div style="display: flex;justify-content: center;align-items: center;margin-bottom: 20px">
                    <Button @click="passOrNot(1)" type="primary" class="button-right">审核通过</Button>
                    <Button @click="noPass" type="warning" class="button-right">拒绝通过</Button>
                </div>
            </Form>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js'
    import previewImg from '@/components/previewImg'

    export default {
        components:{previewImg},
        name: 'tqtCompanyForm',
        data () {
            return {
                //ID
                id: null,
                saveLoading: false,
                type: '',
                //表单参数
                model: {
                    companyName: '',
                    unifiedSocialCreditCode: '',
                    legalman: '',
                    contactMobile: '',
                    companyAddress: '',
                    concatName: '',
                    businessRange: '',
                    area: '',
                    concatPhone: '',
                    concatAddress: '',
                    createTime: '',
                    buildTime: '',
                },
            }
        },
        mounted () {
            this.type = this.$route.query.type || ''
            if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
                this.id = this.$route.query.id
                //ID存在渲染表单
                this.initForm()
            }
        },
        methods: {
            formatTime (UTCDateString) {
                if (!UTCDateString) {
                    return '-'
                }

                function formatFunc (str) {    //格式化显示
                    return str > 9 ? str : '0' + str
                }

                var date2 = new Date(UTCDateString)     //这步是关键
                var year = date2.getFullYear()
                var mon = formatFunc(date2.getMonth() + 1)
                var day = formatFunc(date2.getDate())
                var hour = date2.getHours()
                var min = formatFunc(date2.getMinutes())
                var second = date2.getSeconds()
                // var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + second
                var dateStr = year + '-' + mon + '-' + day
                return dateStr
            },
            //保存
            save () {
                this.$router.push({
                    name: 'tqt_companyrenyuanguanli_item',
                    query: {
                        id: this.model.id,
                        unifiedSocialCreditCode: this.model.unifiedSocialCreditCode,
                    }
                })

            },

            create () {
                let _this = this
                _this.saveLoading = true
                util.http.post('/api/tqtCompanys', this.model, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {
                    _this.$Notice.success({
                        title: '保存成功!'
                    })
                    _this.back()
                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '保存失败!'
                    })
                    _this.saveLoading = false
                    console.log(error)
                })
            },

            update () {
                let _this = this
                _this.saveLoading = true
                util.http
                        .put('/api/tqtCompanys', this.model, {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '更新成功!'
                            })
                            _this.back()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '更新失败!'
                            })
                            _this.saveLoading = false
                            console.log(error)
                        })
            },

            //渲染表单
            initForm () {
                let _this = this
                util.http.get('/api/tqtCompanyVerify/' + this.id, {
                    params: {}
                }).then(function (response) {
                    let tem = response.data

                    _this.model = tem
                    _this.model.formatBuildTime = _this.formatTime(_this.model.buildTime)
                    _this.model.formatCreateTime = _this.formatTime(_this.model.createTime)
                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '获取表单失败!'
                    })
                    console.log(error)
                })
            },

            //返回,需要自定义配置路由
            back () {
                let _this = this
                let tagName = _this.$route.name
                _this.$store.commit('removeTag', tagName)
                _this.$store.commit('closePage', tagName)
                _this.$router.push({
                    name: 'tqt_company'
                })
            },
            passOrNot () {
                this.$confirm('即将通过?', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.post('/api/verifyTqtUserExamines', {
                        id: this.model.id,
                        status: 1
                    }).then(res => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: '审核通过!'
                            });
                        }
                    }).catch(res => {
                        this.$message({
                            type: 'warning',
                            message: '审核失败'
                        });
                    });

                })

            },
            noPass () {
                this.$prompt('请输入拒绝原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '拒绝原因不能为空'
                }).then(({ value }) => {
                    this.$http.post('/api/verifyTqtUserExamines', {
                        id: this.model.id,
                        status: 2,
                        remark: value,
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '已拒绝!'
                        });
                        this.$router.push({
                            name: 'tqt_company'
                        })
                    }).catch(res => {
                        this.$message({
                            type: 'warning',
                            message: '拒绝已取消！'
                        });
                    });
                })
            }
        }
    }
</script>

<style scoped>
    .button-area {
        display: flex;
        justify-content: flex-end;
    }

    .button-right-left {
        margin-right: 15px;
    }

    .button-right {
        margin-right: 55px;
    }

    .form-area {
        display: flex;
        justify-content: center;
    }

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .model-hidden {
        display: none;
    }
    .img-con{
        display: flex;
        flex-wrap: wrap;
    }
</style>
